import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';

import PassengerSeat from 'components/AirlineSeatSelection/PassengerSeat';
import PopoverTriggerLayout from 'layouts/PopoverTriggerLayout/PopoverTriggerLayout';
import { flightSeatAttributes, nonSeatAttributes } from 'constants/flightSeats';
import AirlineSeat from './AirlineSeat';

import './SeatListSeat.scss';

const mapStateToProps = (state, ownProps) => ({
  selectedSeats: state.bookState.getIn(['booking_info', 'selection', 'flight_seats', ownProps.direction], Immutable.Map()),
  passengers: state.bookState.getIn(['booking_info', 'airlineSeatPassenger']),
});

export class SeatListSeat extends PureComponent {
  static propTypes = {
    flightSeat: ImmutablePropTypes.mapContains({
      available: PropTypes.bool.isRequired,
      flightSeatAttributes: ImmutablePropTypes.listOf(PropTypes.string),
      seatNumber: PropTypes.string,
    }),
    rowNumber: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    onHover: PropTypes.func.isRequired,
    isHovered: PropTypes.bool.isRequired,
    direction: PropTypes.string.isRequired,
    selectedSeats: ImmutablePropTypes.map.isRequired,
    passengers: ImmutablePropTypes.list.isRequired,
    paxType: PropTypes.string.isRequired,
  };

  state = {
    popoverData: undefined,
    isForbidden: false,
  };

  componentDidMount() {
    const { flightSeat, paxType } = this.props;
    this.updateSeatState(flightSeat, paxType);
  }

  componentWillReceiveProps(newProps) {
    const { flightSeat, paxType } = newProps;
    this.updateSeatState(flightSeat, paxType);
  }

  forbiddenChildPopoverContent = {
    id: 'seat-list-seat__forbidden-child',
    body: 'Sorry, Children can\'t sit here',
  };

  forbiddenInfantPopoverContent = {
    id: 'seat-list-seat__forbidden-infant',
    body: 'This seat is not suitable for an adult carrying an infant',
  };

  exitRowPopoverContent = {
    id: 'seat-list-seat__exit-row',
    body: 'You must be over 16 years of age and have no mobility impairments to sit in this seat',
  };

  unavailableSeatPopoverContent = {
    id: 'seat-list-seat__occupied',
    body: 'This seat is already taken',
  };

  updateSeatState(flightSeat, paxType) {
    const seatAttributes = flightSeat.get('flightSeatAttributes') || Immutable.List();
    let popoverData;
    let isForbidden = false;

    const isSeatReallyASeat = !nonSeatAttributes.some(nonSeatAttribute => seatAttributes.includes(nonSeatAttribute));
    const isSeatForbiddenBecauseInfant = paxType === 'adultWithInfant' && !seatAttributes.includes(flightSeatAttributes.INFANTS_ALLOWED);
    const isSeatForbiddenBecauseChild = paxType === 'child' && !seatAttributes.includes(flightSeatAttributes.CHILDREN_ALLOWED);

    if (isSeatReallyASeat) {
      if (!flightSeat.get('available')) {
        popoverData = this.unavailableSeatPopoverContent;
        isForbidden = true;
      } else if (isSeatForbiddenBecauseChild) {
        popoverData = this.forbiddenChildPopoverContent;
        isForbidden = true;
      } else if (isSeatForbiddenBecauseInfant) {
        popoverData = this.forbiddenInfantPopoverContent;
        isForbidden = true;
      } else if (seatAttributes.includes(flightSeatAttributes.EXIT_ROW)) {
        popoverData = this.exitRowPopoverContent;
      }
    } else {
      isForbidden = true;
    }

    this.setState({
      popoverData,
      isForbidden,
    });
  }

  getPassenger() {
    const { selectedSeats, passengers, rowNumber, flightSeat, isHovered } = this.props;
    const { isForbidden } = this.state;

    let seatPassenger;

    if (isHovered && !isForbidden) {
      seatPassenger = Immutable.fromJS({
        paxType: this.props.paxType,
      });
    } else {
      const passengerId = selectedSeats.findKey(seat => seat.get('row') === rowNumber && seat.get('seat') === flightSeat.get('seatNumber'));
      if (passengerId !== undefined) {
        seatPassenger = passengers.find(passenger => `${passenger.get('id')}` === passengerId);
      }
    }

    return seatPassenger;
  }

  handleSeatClick = (event) => {
    event.preventDefault();

    const { rowNumber, flightSeat, onClick } = this.props;
    const { isForbidden } = this.state;

    if (!isForbidden) {
      onClick(rowNumber, flightSeat.get('seatNumber'));
    }
  };

  handleMouseEnter = () => {
    const { rowNumber, flightSeat, onHover } = this.props;
    onHover(rowNumber, flightSeat.get('seatNumber'), true);
  };

  handleMouseLeave = () => {
    const { rowNumber, flightSeat, onHover } = this.props;
    onHover(rowNumber, flightSeat.get('seatNumber'), false);
  };

  render() {
    const { flightSeat, paxType, rowNumber, isHovered } = this.props;
    const { popoverData, isForbidden } = this.state;
    const passenger = this.getPassenger();

    let airlineSeat = passenger ? (
      <PassengerSeat
        counter={passenger.get('counter')}
        paxType={passenger.get('paxType')}
        hover={isHovered}
      />
    ) : (
      <AirlineSeat
        flightSeat={flightSeat}
        rowNumber={rowNumber}
        paxType={paxType}
      />
    );

    if (popoverData) {
      airlineSeat = (
        <PopoverTriggerLayout
          extraClass="seat-list-seat__popover-trigger"
          content={popoverData}
          position="auto"
        >
          {airlineSeat}
        </PopoverTriggerLayout>
      );
    }

    return (
      <div
        onClick={this.handleSeatClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        tabIndex={isForbidden ? undefined : 0}
      >
        {airlineSeat}
      </div>
    );
  }
}

export default connect(mapStateToProps)(SeatListSeat);



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/SeatListSeat.jsx
 **/